"use strict";import{Badge as e}from"./src/Badge.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-badge",e);
//# sourceMappingURL=sp-badge.js.map
